/* ============================================
   BENITEZ - Hero Slideshow
   Imagen + texto cambian juntos. Auto-rotación,
   flechas y dots de navegación.
   ============================================ */
(function () {
  function initSlideshow() {
    var root = document.getElementById('bz-slideshow');
    if (!root) return;

    var slides = root.querySelectorAll('.bz-slide');
    var dots = root.querySelectorAll('.bz-dot');
    var prev = document.getElementById('bz-slide-prev');
    var next = document.getElementById('bz-slide-next');
    if (slides.length === 0) return;

    var current = 0;
    var timer = null;
    var INTERVAL = 6000;

    function show(index) {
      if (index < 0) index = slides.length - 1;
      if (index >= slides.length) index = 0;
      current = index;
      for (var i = 0; i < slides.length; i++) {
        slides[i].classList.toggle('is-active', i === current);
      }
      for (var d = 0; d < dots.length; d++) {
        dots[d].classList.toggle('is-active', d === current);
      }
    }

    function nextSlide() { show(current + 1); }
    function prevSlide() { show(current - 1); }

    function startAuto() {
      stopAuto();
      timer = setInterval(nextSlide, INTERVAL);
    }
    function stopAuto() {
      if (timer) { clearInterval(timer); timer = null; }
    }
    function restart() { startAuto(); }

    if (next) next.addEventListener('click', function () { nextSlide(); restart(); });
    if (prev) prev.addEventListener('click', function () { prevSlide(); restart(); });

    for (var k = 0; k < dots.length; k++) {
      (function (idx) {
        dots[idx].addEventListener('click', function () {
          show(idx);
          restart();
        });
      })(k);
    }

    // Pausar al pasar el cursor
    root.addEventListener('mouseenter', stopAuto);
    root.addEventListener('mouseleave', startAuto);

    show(0);
    if (slides.length > 1) startAuto();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSlideshow);
  } else {
    initSlideshow();
  }
})();
